<template>
  <div :class="{ fixed }">
    <table class="table table-striped">
      <tbody>
        <tr
          v-for="(field) in fields"
          :key="field.key"
        >
          <td>
            <div class="field__header">
              <span
                :class="{ 'bold': visible[field.key] }"
                @click="toggle(field.key)"
              >
                <i
                  :class="{
                    'fa-plus-square-o': !visible[field.key],
                    'fa-minus-square-o': visible[field.key]
                  }"
                >
                  class="fa"
                </i>
                &nbsp;{{ field.key }}
              </span>
            </div>
            <div
              v-show="visible[field.key]"
              class="template__body"
            >
              {{ field.name }}
              <small v-if="field.description.length > 0"><br>{{ field.description }}</small>
              <div class="field__example">
                <small>
                  <b>Default:</b><br>
                  <template v-if="field.default.length > 0">{{ field.default }}</template>
                  <template v-else>empty</template>
                </small>
              </div>
              <div class="field__actions">
                <button
                  class="btn btn-sm btn-primary"
                  @click.prevent="edit(field.key)"
                >
                  <i class="fa fa-pencil-square-o" /> {{ $t('Edit') }}
                </button>
                <button
                  class="btn btn-sm btn-danger"
                  @click.prevent="remove(field.key)"
                >
                  <i class="fa fa-trash" /> {{ $t('Delete') }}
                </button>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <a
      v-if="!hideAddButton"
      href="#"
      class="modal-floating-button"
      @click.prevent="add"
    >
      <i class="fa fa-plus" />
    </a>
  </div>
</template>

<script>
export default {
  name: 'AppMarketplaceFields',
  props: {
    value: {
      type: Object,
      required: true,
    },
    fixed: {
      type: Boolean,
      default: true,
    },
    hideAddButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fields: [],
      visible: {},
    };
  },
  watch: {
    value: {
      handler(v) {
        this.fields = Object.keys(v).map(i => ({ key: i, ...v[i] }));
        const visible = {};
        this.fields.forEach(e => {
          visible[e.key] = false;
        });
        this.visible = visible;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    toggle(key) {
      this.$set(this.visible, key, !this.visible[key]);
    },
    remove(key) {
      this.$emit('delete', key);
    },
    edit(key) {
      this.$emit('edit', key);
    },
    add() {
      this.$emit('add');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~bootstrap-vars";

  table {
    width: 100%;
  }

  .fixed {
    overflow-y: auto;
    max-height: calc(100vh - 300px);
  }

  .field {
    &__header {
      cursor: pointer;
    }
    &__body {
      padding-left: 18px;
    }
    &__actions {
      margin-top: 10px;
    }
    &__example {
      border: $gray-300 1px solid;
      padding: 5px;
      margin-top: 5px;
    }
  }
</style>
